// Role tiers — mirrors backend server.py
export const MANAGER_TIER = ["manager", "assistant_manager", "inventory_manager"];
export const EMPLOYEE_TIER = ["employee", "zone_owner", "cashier", "inventory_assistant"];
export const STAFF_ROLES = [...MANAGER_TIER, ...EMPLOYEE_TIER];
export const ALL_ROLES = ["admin", "gm", "global_standards", ...STAFF_ROLES];

export const ROLE_LABELS = {
  admin: "Admin",
  gm: "General Manager",
  manager: "Manager",
  assistant_manager: "Assistant Manager",
  inventory_manager: "Inventory Manager",
  employee: "Employee",
  zone_owner: "Zone Owner",
  cashier: "Cashier",
  inventory_assistant: "Inventory Assistant",
  global_standards: "Global Standards Team",
};

export const ROLE_OPTIONS = [
  { value: "admin", label: "Admin" },
  { value: "gm", label: "General Manager" },
  { value: "global_standards", label: "Global Standards Team" },
  { value: "manager", label: "Manager" },
  { value: "assistant_manager", label: "Assistant Manager" },
  { value: "inventory_manager", label: "Inventory Manager" },
  { value: "employee", label: "Employee" },
  { value: "zone_owner", label: "Zone Owner" },
  { value: "cashier", label: "Cashier" },
  { value: "inventory_assistant", label: "Inventory Assistant" },
];

export const isManagerTier = (r) => MANAGER_TIER.includes(r);
export const isEmployeeTier = (r) => EMPLOYEE_TIER.includes(r);
export const roleLabel = (r) => ROLE_LABELS[r] || r || "";

// Expand a route's declared roles so that "manager" also grants access to
// assistant_manager / inventory_manager, and "employee" grants access to
// zone_owner / cashier / inventory_assistant. Mirrors backend _expand_roles.
export function hasAccess(userRole, allowedRoles) {
  if (!allowedRoles || allowedRoles.length === 0) return true;
  const set = new Set(allowedRoles);
  if (set.has("manager")) MANAGER_TIER.forEach((r) => set.add(r));
  if (set.has("employee")) EMPLOYEE_TIER.forEach((r) => set.add(r));
  return set.has(userRole);
}
